import { SelectorUtil } from '../../utils/selector-util';

export class HiddenBlockRenderer {
    public render(): HTMLElement {
        const container = document.createElement('div');
        container.id = SelectorUtil.hiddenVarsBlockId;
        container.style.display = 'none';
        return container;
    }
}
